import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  getAllBrandsList,
  getAllCategoryNoLimit,
  getAllProducts,
} from "../../../redux/features/assetManagementSlice";
import { Product_Table_Head } from "../../../components/datagrid/assetmanagement/ProductTableHead";
import AddProduct from "./AddProduct";
import EditProduct from "./EditProduct";
import GlobalMultiSelect from "../../../components/mui/GlobalMultiSelect";
import GlobalMultiSelectNew from "../../../components/mui/GlobalMultiSelectNew";
import DeleteProduct from "./DeleteProduct";
import GlobalMultiSelectId from "../../../components/mui/GlobalMultiSelectId";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import apiRequest from "../../../api/request";

const Product = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { productData, loading, brandDataList, categoryAllData } = useSelector(
    (state) => state.assetmanagement
  );
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const [selectedBrands, setSelectedBrands] = useState("");
  const [selectedCategories, setSelectedCategories] = useState("");

  const data = {
    page: pageNum,
    limit: gridSize,
    category: selectedCategories,
    brand: selectedBrands,
    status: 0,
    date: dayjs(value).format("YYYY-MM"),
    search: search,
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getAllProducts(data));
    }
  }, [pageNum, gridSize, value, selectedBrands, selectedCategories,search]);

  useEffect(() => {
    dispatch(getAllBrandsList());
    dispatch(getAllCategoryNoLimit());
  }, []);

  // Export should include every record matching the current filters/search (limit=no returns all rows)
  const fetchAllProductsForExport = async () => {
    const res = await apiRequest({
      method: "get",
      url: `products/?page=1&limit=no&product_status=${data.status}&category_id=${data.category}&brand_id=${data.brand}&search=${encodeURIComponent(data?.search)}`,
    });
    return res?.data || [];
  };

  const handlecategory = (event) => {
    const selectedValue = event.target.value;

    setSelectedCategories(selectedValue);
  };

  const handleBrand = (event) => {
    const selectedValue = event.target.value;

    setSelectedBrands(selectedValue);
  };

  return (
    <GlobalWrapper
      title={"Products"}
      actions={<AddProduct dispatchParams={data} />}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: 2,
          gap: 1,
          flexDirection: {
            xs: "column",
            sm: "row",
          },
        }}
      >
        <FormControl>
          <InputLabel id="cat">Category</InputLabel>
          <Select
            value={selectedCategories}
            label="Category"
            onChange={handlecategory}
            sx={{
              width: "250px",
            }}
          >
            <MenuItem value="" defaultValue>
              All
            </MenuItem>
            {categoryAllData.data?.map((cat) => (
              <MenuItem key={cat.category_id} value={cat.category_id}>
                {cat.category_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel id="brand">Brand</InputLabel>
          <Select
            value={selectedBrands}
            label="Brand"
            onChange={handleBrand}
            sx={{
              width: "250px",
            }}
          >
            <MenuItem value="" defaultValue>
              All
            </MenuItem>
            {brandDataList.data?.map((bnd) => (
              <MenuItem key={bnd.brand_id} value={bnd.brand_id}>
                {bnd.brand_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Product_Table_Head}
          rows={productData.data}
          meta={productData?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          exportAllRows={fetchAllProductsForExport}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.product_name} />
              <GlobalAnchorList
                label=""
                component={
                  <EditProduct rowData={rowData} dispatchParams={data} />
                }
              />
              <GlobalAnchorList
                label=""
                component={
                  <DeleteProduct
                    rowData={rowData}
                    data={data}
                    id={rowData?.product_id}
                  />
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Product;
